/**
 * Asynchronously loads the component for PatientList
 */

import React from 'react'
import { lazyLoad } from 'utils/loadable'
import { LoadingWrapper } from 'app/components/LoadingWrapper'
import { LoadingIndicator } from 'app/components/LoadingIndicator'

export const PatientList = lazyLoad(
  () => import('./index'),
  module => module.PatientList,
  {
    fallback: (
      <LoadingWrapper>
        <LoadingIndicator />
      </LoadingWrapper>
    ),
  },
)
